import { render, staticRenderFns } from "./EditingFormField.vue?vue&type=template&id=534809c4&scoped=true&"
import script from "./EditingFormField.vue?vue&type=script&lang=js&"
export * from "./EditingFormField.vue?vue&type=script&lang=js&"
import style0 from "./EditingFormField.vue?vue&type=style&index=0&id=534809c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534809c4",
  null
  
)

export default component.exports